/**
* По клику или ховеру по элементу-триггеру показываем попап.
* Можно указывать кастомные хендлеры onShow, onHide,
* можно использовать стандартные - тогда указать какой css класс добавить к попапу / триггеру.
*/
export default class SimplePopup {
    hideCurrent() {
        if (currentInstance) {
            currentInstance.hide();
        }
    }

    hide() {
        clearTimeout(this.hideTimerId);
        clearTimeout(this.showTimerId);
        if (!this.visible) {
            return;
        }

        this.setVisiblity(false);
        if (this === currentInstance) {
            currentInstance = null;
        }
        this.settings.onHide();
    }

    show() {
        if (this !== currentInstance) {
            this.hideCurrent();
        }
        clearTimeout(this.hideTimerId);
        clearTimeout(this.showTimerId);
        if (!this.visible) {
            this.setVisiblity(true);
            this.settings.onShow();
        }
    }

    setVisiblity(isVisible) {
        this.visible = isVisible;

        var elementWithExpanded = this.settings.toggleControl ? this.settings.toggleControl : this.trigger;
        elementWithExpanded.ariaExpanded = isVisible.toString();
    }

    hideOnTimer() {
        clearTimeout(this.hideTimerId);
        clearTimeout(this.showTimerId);
        this.hideTimerId = setTimeout(this.hide.bind(this), this.settings.timeout);
    }

    showOnTimer() {
        if (this.settings.showTimeout > 0) {
            clearTimeout(this.hideTimerId);
            clearTimeout(this.showTimerId);
            this.showTimerId = setTimeout(this.show.bind(this), this.settings.showTimeout);
        } else {
            this.show();
        }
    }

    onClickHandler() {
        if (!this.visible) {
            this.show();
        } else if (!this.settings.remainOnClick) {
            this.hide();
        }
    }

    toggleHandler(event) {
        event.stopPropagation();
        if (this.visible) {
            this.hide();
        } else {
            this.show();
        }
    }

    onMouseenterHandler() {
        this.showOnTimer();
    }

    onTouchendHandler() {
        if (this.visible) {
            this.hideOnTimer();
        }
    }

    processEvents(handler) {
        // Может быть только click и mouseenter
        var eventList = this.settings.event.split(' ');
        var isFocusEventEnabled = eventList.includes('focus');
        var instance = this;

        if (instance.trigger) {
            eventList.forEach(function (event) {
                switch (event) {
                    case 'click':
                        handler.call(instance.trigger, 'click', instance.triggerClickHandler);
                        break;
                    case 'mouseenter':
                        handler.call(instance.trigger, 'mouseenter', instance.triggerMouseenterHandler);
                        break;
                }
            });

            handler.call(instance.popup, 'mouseenter', instance.popupMouseenterHandler);

            if (isFocusEventEnabled) {
                handler.call(instance.trigger, 'focusin', instance.triggerMouseenterHandler);
                handler.call(instance.popup, 'focusin', instance.popupMouseenterHandler);
            }

            if (this.triggerMouseleaveHandler) {
                handler.call(instance.trigger, 'mouseleave', instance.triggerMouseleaveHandler);
                if (isFocusEventEnabled) {
                    handler.call(instance.trigger, 'focusout', instance.triggerMouseleaveHandler);
                }
            }
        }

        if (this.popupMouseleaveHandler) {
            handler.call(instance.popup, 'mouseleave', instance.popupMouseleaveHandler);
            if (isFocusEventEnabled) {
                handler.call(instance.popup, 'focusout', instance.popupMouseleaveHandler);
            }
        }

        if (OK.device.isTouch) {
            if (instance.trigger) {
                handler.call(instance.trigger, 'touchend', instance.triggerTouchendHandler);
            }
            handler.call(document.body, 'touchend', instance.bodyTouchendHandler);
        }

        if (this.settings.toggleControl) {
            handler.call(this.settings.toggleControl, 'click', instance.toggleClickHandler);
        }

    }

    /**
     *
     * @param {HTMLElement} trigger
     * @param {HTMLElement} popup
     * @param {Object} o
     */
    create(trigger, popup, o) {
        if (!popup) {
            return;
        }

        this.trigger = trigger;
        this.popup = popup;

        this.showTimerId = null;
        this.hideTimerId = null;
        this.visible = false;

        // Иначе перетрет значением по-умолчанию
        o.timeout = o.timeout !== 0
            ? o.timeout
            : 1;

        this.settings = {
            event: o.event || "click",
            timeout: o.timeout || 800,
            showTimeout: o.showTimeout || 0,
            remainOnClick: o.remainOnClick || false,
            onShow: o.onShow || emptyFn,
            onHide: o.onHide || emptyFn,
            toggleControl: o.toggleControl
        };

        this.triggerClickHandler = this.onClickHandler.bind(this);
        this.triggerMouseenterHandler = this.onMouseenterHandler.bind(this);
        this.popupMouseenterHandler = this.showOnTimer.bind(this);
        this.bodyTouchendHandler = this.onTouchendHandler.bind(this);
        this.triggerTouchendHandler = function (e) {
            e.stopPropagation();
        };

        if (!OK.logging.isSeleniumBot) {
            this.triggerMouseleaveHandler = this.hideOnTimer.bind(this);
            this.popupMouseleaveHandler = this.hideOnTimer.bind(this);
        }

        if (this.settings.toggleControl) {
            this.toggleClickHandler = this.toggleHandler.bind(this);
        }

        this.processEvents(window.Element.prototype.addEventListener);
    }

    /**
     * Возвращает элемент для селектора в произвольной нотации
     * @param {string} selector
     * @returns {?HTMLElement}
     */
    getElement(selector) {
        if (!selector) {
            return null; // эквивалентно ненайденному элементу
        }

        // Искомый селектор может находится в любом  месте документа
        // querySelector('#...') не работает, нужно доп. экранирование
        return selector.charAt(0) === '#'
            ? document.getElementById(selector.slice(1))
            : document.querySelector(selector);
    }

    /**
     *
     * @param {HTMLElement} element
     */
    activate(element) {
        var DATA_POPUP_ACTIVE_CLASS = 'data-popup-active-class';
        var DATA_POPUP_LOCAL_SELECTOR = 'data-popup-local-selector';
        // триггер, по которому кликаем (наводим мышь)
        var triggerElement = this.getElement(element.getAttribute('data-trigger-selector'));
        var trigger = !!triggerElement
            ? triggerElement
            : element;

        // селектор попапа. При активации триггера происходит добавление класса popupActiveClassName - попап должен появиться
        var popup = element.hasAttribute(DATA_POPUP_LOCAL_SELECTOR)
            ? element.querySelector(element.getAttribute(DATA_POPUP_LOCAL_SELECTOR))
            : this.getElement(element.getAttribute('data-popup-selector'));
        var popupActiveClassName = element.getAttribute(DATA_POPUP_ACTIVE_CLASS) || null;
        var popupHiddenClassName = element.getAttribute('data-popup-hidden-class') || '';
        var timeout = parseInt(element.getAttribute('data-timeout'), 10);
        var showTimeout = parseInt(element.getAttribute('data-show-timeout'), 10);
        // По какому событию активировать триггер - показывать попап. Например click, mouseenter.
        var event = element.getAttribute('data-event');
        // При активации триггера происходит добавлять data-active-class на триггер
        var triggerActiveClassName = element.getAttribute('data-active-class') || '';
        var remainOnClick = element.hasAttribute('data-remain-on-click');
        var toggleControl = element.hasAttribute('data-toggle-selector')
            ? element.querySelector(element.getAttribute('data-toggle-selector'))
            : null;

        var singleton = element.getAttribute('data-singleton') === '1';

        if (popupActiveClassName === null || popupActiveClassName.indexOf(' ') !== -1) {
            // Если на попапе было <div class='a b c'/>, то после показа и скрытия останется <div class='c'/>
            if (OK.fn.isDebug()) {
                window.console.error(`OK/SimplePopup bad usage on ${popup}. Use "${DATA_POPUP_ACTIVE_CLASS}"`);

                if (OK.fn.isAlertsEnabled()) {
                    window.alert('OK/SimplePopup bad usage. See console log for details');
                }
            }
        }

        var that = this;

        this.create(trigger, popup, {
            timeout: timeout,
            showTimeout: showTimeout,
            event: event,
            remainOnClick: remainOnClick,
            toggleControl: toggleControl,

            onShow: function () {
                popup.classList.add(popupActiveClassName);

                // Будем проставлять модификатор для инверсии направления, если контент не будет влезать
                if (popup.getBoundingClientRect().bottom > window.innerHeight) {
                    popup.classList.add("__top");
                }
                if (popupHiddenClassName) {
                    popup.classList.remove(popupHiddenClassName);
                }
                if (triggerActiveClassName) {
                    trigger.classList.add(triggerActiveClassName);
                }
                if (singleton) {
                    currentInstance = that;
                }
            },

            onHide: function () {
                popup.classList.remove(popupActiveClassName, '__top');
                if (popupHiddenClassName) {
                    popup.classList.add(popupHiddenClassName);
                }
                if (triggerActiveClassName) {
                    trigger.classList.remove(triggerActiveClassName);
                }
            }
        });

        if (element.hasAttribute('data-expanded')) {
            this.show();
        }
    }

    deactivate() {
        if (this.settings) {
            this.processEvents(window.Element.prototype.removeEventListener);
        }
    }
}

var emptyFn = function () {};
var currentInstance = null;
